import React from 'react';
import { useTranslation } from 'react-i18next';
import { SentimentBadge } from '@/components/SentimentBadge';
import type { DiaryBehaviourEntry } from '@/types/diary';
import { linkifyText } from '@/utils/html';
import { BULLET_SYMBOL } from '@/utils/text';

interface Props {
  entry: DiaryBehaviourEntry;
}

export const BehaviourEntryItem: React.FC<Props> = ({ entry }) => {
  const { t } = useTranslation();
  const hasSubject = !!entry.subject;
  const hasAuthorName = !!entry.authorName;

  return (
    <div className="flex flex-col gap-2 px-4 py-[11px]">
      <div className="flex items-start gap-4">
        <span className="text-subhead-14 min-w-0 text-foreground">
          {hasSubject && entry.subject}
          {hasSubject && hasAuthorName && (
            <span className="text-body-14">{` ${BULLET_SYMBOL} `}</span>
          )}
          {hasAuthorName && (
            <span className="whitespace-nowrap">{entry.authorName}</span>
          )}
        </span>

        <div className="flex shrink-0 items-center gap-2">
          <span className="text-caption-12 shrink-0 rounded-xl border border-transparent bg-purple-soft px-2 py-0.5 text-primary contrast:border-border">
            {t('diary.notes.behaviourEntry')}
          </span>
          {!!entry.type && <SentimentBadge type={entry.type} />}
        </div>
      </div>

      <p
        className="rich-text text-body-14 text-subtle-foreground"
        dangerouslySetInnerHTML={{ __html: linkifyText(entry.text) }}
      />
    </div>
  );
};
